import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * User Anonymous Icon Component
 * User avatar icon - outlined circle with person silhouette
 * Used for anonymous/guest user display
 */
class UserAnonIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '1.5',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
            />
        `;
    }
}

customElements.define('user-anon-icon', UserAnonIcon);
